'use client';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { Paragraph } from '../../../ui/paragraph';

export function ProductAccordionDescription() {
  const { t } = useTranslations();
  const product = useVariantsStore(s => s.product);
  const selectedVariant = useVariantsStore(s => s.selectedVariant);

  const description = selectedVariant?.description || product.description;
  if (!description) return null;

  return (
    <Paragraph innerHtml={description} className="w-full" color="muted-foreground" size="base" />
  );
}
